import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AuthService} from '../services/auth.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/map';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isLoggedIn.take(1)
      .map((isLoggedIn: boolean) => {
        if ( !isLoggedIn && this.router.url.indexOf('new-account')==-1) {
          this.router.navigate(['/login']);  // {4}
          return false;
        }
        return true;
      });
    // if (localStorage.getItem('currentUser')) {
    //   return true;
    // }
    // // not logged in so redirect to login page with the return url
    // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
    // return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts